import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

function IconPlus({ size = 20, color = Config.BLACK_5, className }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={`icon-plus`} d="M15.8333 10.8333H10.8333V15.8333H9.16667V10.8333H4.16667V9.16667H9.16667V4.16667H10.8333V9.16667H15.8333V10.8333Z" fill={color}/>
    </svg>
  )
}

IconPlus.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default IconPlus;
